import { render, staticRenderFns } from "./GroupDropdown.vue?vue&type=template&id=3670c410"
import script from "./GroupDropdown.js?vue&type=script&lang=js&external"
export * from "./GroupDropdown.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports